export const LEGACY_ORG_ID = 'ORG-LEGACY';

export const SCOPED_CACHE_PREFIXES = [
  'probaworkflows.caseReportConfiguration.',
  'compliance_onboarding_gate:',
];

export function is_real_organization(organization) {
  return Boolean(
    organization?.id
    && organization.external_org_id !== LEGACY_ORG_ID
  );
}
